export default "__VITE_ASSET__tmQVLmwt__"